module.exports = __webpack_public_path__ + "img/financial-accounting-icon.c836a8b9.png";